module.exports = __webpack_public_path__ + "media/images/athletes/3563-7d9c197fa54bcca8e79c2ff19d98fca3.png";